import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ResolveEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { LayoutService } from '../../core/layout.service';
import { PageInfoService } from '../../core/page-info.service';
import { Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { MenuComponent } from '../../../kt/components/MenuComponent';
import { ScrollComponent } from '../../../kt/components/_ScrollComponent';
import { DrawerComponent } from '../../../kt/components/_DrawerComponent';
import { ToggleComponent } from '../../../kt/components/_ToggleComponent';

@Component({
	selector: 'app-scripts-init',
	templateUrl: './scripts-init.component.html',
	imports: [CommonModule],
	standalone: true,
})
export class ScriptsInitComponent implements OnInit, OnDestroy {
	private unsubscribe: Subscription[] = [];
	private layout = inject(LayoutService);
	private pageInfo = inject(PageInfoService);
	private router = inject(Router);
	private titleService = inject(Title);

	constructor() {
		const initPageInfo = () => {
			setTimeout(() => {
				this.pageInfo.calculateTitle();
				this.pageInfo.calculateBreadcrumbs();

				this.pageInfo.title.asObservable().subscribe((title) => {
					this.titleService.setTitle('Loyalty Card');
				});
			}, 10);
		};

		initPageInfo();
		// subscribe to router events
		this.router.events.pipe(filter((event) => event instanceof ResolveEnd)).subscribe(initPageInfo);
	}

	ngOnInit(): void {
		this.pluginsInitialization();
		const layoutUpdateSubscription = this.layout.layoutConfigSubject.asObservable().subscribe(() => {
			this.pluginsReInitialization();
		});
		this.unsubscribe.push(layoutUpdateSubscription);
	}

	pluginsInitialization() {
		setTimeout(() => {
			ToggleComponent.bootstrap();
			DrawerComponent.bootstrap();
			MenuComponent.bootstrap();
			ScrollComponent.bootstrap();
		}, 200);
	}

	pluginsReInitialization() {
		setTimeout(() => {
			MenuComponent.reinitialization();
			DrawerComponent.reinitialization();
			ToggleComponent.reinitialization();
			ScrollComponent.reinitialization();
		}, 100);
	}

	ngOnDestroy() {
		this.unsubscribe.forEach((sb) => sb.unsubscribe());
	}
}
